var _$helpers_12 = {
  classify: _$classify_5,
  COLORS: _$colors_6,
  formatStyle: _$formatStyle_8,
  /* common-shake removed: fmtComma: require("./fmtComma") */
  /* common-shake removed: getAPMonth: require("./getAPMonth") */
  /* common-shake removed: getLocation: require("./getLocation") */
  getParameterByName: _$getParameterByName_11,
  /* common-shake removed: isProduction: require("./isProduction") */
  lookupColor: _$lookupColor_14,
  makeTranslate: _$makeTranslate_15,
  parseNumber: _$parseNumber_16,
  urlToLocation: _$urlToLocation_17,
  /* common-shake removed: wrapText: require("./wrapText") */
};

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbIm1vZHVsZSIsImNsYXNzaWZ5IiwicmVxdWlyZSIsIkNPTE9SUyIsImZvcm1hdFN0eWxlIiwiZ2V0UGFyYW1ldGVyQnlOYW1lIiwibG9va3VwQ29sb3IiLCJtYWtlVHJhbnNsYXRlIiwicGFyc2VOdW1iZXIiLCJ1cmxUb0xvY2F0aW9uIl0sIm1hcHBpbmdzIjoiQUFJQUEsZ0JBQUFBLEdBQWlCO0VBQ2ZDLFFBQUFBLEVBQVVDLFlBREs7RUFFZkMsTUFBQUEsRUFBUUQsVUFGTztFQUdmRSxXQUFBQSxFQUFhRixlQUhFOzs7O0VBT2ZHLGtCQUFBQSxFQUFvQkgsdUJBUEw7O0VBU2ZJLFdBQUFBLEVBQWFKLGdCQVRFO0VBVWZLLGFBQUFBLEVBQWVMLGtCQVZBO0VBV2ZNLFdBQUFBLEVBQWFOLGdCQVhFO0VBWWZPLGFBQUFBLEVBQWVQLGtCQVpBOztDQUFqQkYsQ0FBQUEiLCJzb3VyY2VzQ29udGVudCI6W251bGxdfQ==